<template>
  <div class="snowflake-auth-container">
    <FlyRadioCard
      class="fly-radio-card-authentication fly-radio-card-authentication--first"
      label="Authentication Using Password *"
      name="SNOWFLAKE_AUTH_METHODS.PASSWORD"
      help-text="Choose if your user uses password to authenticate."
      :value="SNOWFLAKE_AUTH_METHODS.PASSWORD"
      :selected-value="value"
      :style="{ marginRight: '20px' }"
      @change="handleChange"
    />
    <FlyRadioCard
      v-if="isKeyPairAuthEnabled"
      class="fly-radio-card-authentication"
      label="Authentication Using Key Pair *"
      name="SNOWFLAKE_AUTH_METHODS.KEY_PAIR"
      help-text="Choose if your user uses key pair to authenticate."
      :value="SNOWFLAKE_AUTH_METHODS.KEY_PAIR"
      :selected-value="value"
      @change="handleChange"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapGetters } from 'vuex';
import { getFeatureToggle } from 'web/featureToggle/featureToggleGetterTypes';
import FEATURE_TOGGLE_ENUM from 'shared/featureToggle/FEATURE_TOGGLE_ENUM';
import FlyRadioCard from 'shared/components/Form/FlyRadioCard.vue';

const SNOWFLAKE_AUTH_METHODS = {
  PASSWORD: 'password',
  KEY_PAIR: 'key_pair',
};

export default {
  name: 'SnowflakeAuthenticationOptions',
  components: { FlyRadioCard },
  props: {
    value: VueTypes.string.isRequired,
  },
  emits: ['change'],
  data() {
    return {
      SNOWFLAKE_AUTH_METHODS,
    };
  },
  computed: {
    ...mapGetters({
      getFeatureToggle: getFeatureToggle,
    }),
    isKeyPairAuthEnabled() {
      return this.getFeatureToggle(FEATURE_TOGGLE_ENUM.SNOWFLAKE_KEY_PAIR_AUTH);
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss">
.snowflake-auth-container {
  display: flex;
  border: none;
}

.fly-radio-card-authentication {
  padding: 24px 20px;
  width: 42%;
  width: 42%;

  &.fly-radio-card-authentication--first {
    margin-right: 20px;
  }
}
</style>
